import { render } from "./forwardSet.vue?vue&type=template&id=56f65488&scoped=true"
import script from "./forwardSet.vue?vue&type=script&lang=js"
export * from "./forwardSet.vue?vue&type=script&lang=js"

import "./forwardSet.vue?vue&type=style&index=0&id=56f65488&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\wwei\\ww-vue\\wwei_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f65488"]])

export default __exports__